'use strict';

var REOPTIMIZATION_STATUSES = {
  notOptimized: 'Not Optimized',
  optimizing: 'Optimizing',
  waitingToOptimize: 'Waiting to optimize',
  optimizingError: 'Optimizing error',
  optimized: 'Optimized'
};
var REOPTIMIZATION_STATUSES_MAP = {
  'NEW-REQUEST': REOPTIMIZATION_STATUSES.waitingToOptimize,
  'Started processing...': REOPTIMIZATION_STATUSES.optimizing,
  'STARTED_PROCESSING': REOPTIMIZATION_STATUSES.optimizing,
  'STARTED-PROCESSING': REOPTIMIZATION_STATUSES.optimizing,
  'ERROR-PROCESSING': REOPTIMIZATION_STATUSES.optimizingError,
  'FINISHED-PROCESSING': REOPTIMIZATION_STATUSES.optimized
};
var ScenarioConstants = {
  REOPTIMIZATION_STATUSES: REOPTIMIZATION_STATUSES,
  REOPTIMIZATION_STATUSES_MAP: REOPTIMIZATION_STATUSES_MAP,
  PUBLISHED: 'PUBLISHED',
  ND_PREVIEW_REQUEST: 'NDPreviewRequest',
  MD_PREVIEW_REQUEST: 'MDPreviewRequest'
};
module.exports = ScenarioConstants;